import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=136c5df0"
import script from "./RoleManage.vue?vue&type=script&lang=js"
export * from "./RoleManage.vue?vue&type=script&lang=js"
import style0 from "./system-manage.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports